module.exports = "\r\n<popover #popover\r\n\t\t [hasChanges]=\"hasChanges\"\r\n\t\t [disabled]=\"disabled\"\r\n\t\t (onSave)=\"onSave($event)\"\r\n\t\t (onCancel)=\"onCancel()\"\r\n\t\t [name]=\"name\">\r\n\r\n\t{{displayText}}\r\n\r\n\t<select edit class=\"form-control\" [(ngModel)]=\"selectedItem\" (change)=\"popover.onChange()\" (keyup.Escape)=\"popover.onCancel()\">\r\n\t\t<option *ngFor=\"let item of items\" [ngValue]=\"item\">{{item.name}}</option>\r\n\t</select>\r\n\r\n</popover>";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/editable-popover/specialized/own-region-dropdown.component.html
// module id = 430
// module chunks = 10